require([

	// Typescript
	"hypo_custom/Typescript/ActualDate/ActualDate",
	"hypo_custom/Typescript/IframeResizer/IframeResizer",
	"hypo_custom/Typescript/IframeLoader/IframeLoader",
	"hypo_custom/Typescript/LinksRelSponsored/LinksRelSponsored",
	"hypo_custom/Typescript/Sentry/Sentry",
	"hypo_custom/Typescript/WebVitals/WebVitals",

	// Partials
	"hypo_custom/Partials/FormElement/FormElement",
	"hypo_custom/Partials/Image/Image",
	"hypo_custom/Partials/LabelAndTooltip/LabelAndTooltip",
	"hypo_custom/Partials/Libs/Cookiebot/Cookiebot",
	"hypo_custom/Partials/ModalLink/ModalLink",
	"hypo_custom/Partials/NewsletterAnmeldung/NewsletterAnmeldung",
	"hypo_custom/Partials/Page/BackToTop/BackToTop",
	"hypo_custom/Partials/Page/Header/Header",
	"hypo_custom/Partials/Page/Navigation/Navigation",
	"hypo_custom/Partials/Page/Sociallinks/Sociallinks",

	// Container
	"hypo_custom/Container/AdvertisingSpace/AdvertisingSpace",
	"hypo_custom/Container/FlexibleGrid/FlexibleGrid",
	"hypo_custom/Container/VergleichRechner/VergleichRechner",
	"hypo_custom/Container/WeiterlesenRahmen/WeiterlesenRahmen",

	// Elements
	"hypo_custom/Elements/BaugeldKurzvergleich/BaugeldKurzvergleich",
	"hypo_custom/Elements/Button/Button",

]);
